import React, { memo } from "react";
import styles from "./ContentLayout.module.scss";
type OwnProps<T> = {
  submenu: T | null | undefined;
  actionMenu?: T | null;
  dataView?: T | null | undefined;
};
const ContentLayout = (props: OwnProps<JSX.Element | JSX.Element[]>): JSX.Element => {
  const { submenu, actionMenu, dataView } = props;
  return (
    <div className="table-container">
      <div className={styles.Submenu}>{submenu}</div>
      {actionMenu && <div className="ActionMenu">{actionMenu}</div>}
      <div className={styles.MainContentWrapper}>{dataView}</div>
    </div>
  );
};

export default memo(ContentLayout);
